import { ApiClient } from '../lib/api';
import { User, UserSchema } from '../models/user';
import { CrewRates, CrewRatesSchema } from '../models/crew-rates';

export class UsersService {
    private api: ApiClient;

    constructor(baseURL: string, stage: string) {
        this.api = new ApiClient(`${baseURL}/${stage}/users-service-${stage}`, stage);
    }

    private setDefaults(data: unknown): User {
        return UserSchema.parse(data);
    }

    async getAllUsers(): Promise<User[]> {
        const users = await this.api.request(
            { method: 'GET', url: '/users' },
            UserSchema.array()
        );
        return users.map(user => this.setDefaults(user));
    }

    async getUserById(id: number): Promise<User> {
        const user = await this.api.request(
            { method: 'GET', url: `/users/${id}` },
            UserSchema
        );
        return this.setDefaults(user);
    }

    async getAllSubcontractors(): Promise<User[]> {
        const users = await this.api.request(
            { method: 'GET', url: '/users/sub-contractors' },
            UserSchema.array()
        );
        return users.map(user => this.setDefaults(user));
    }

    async getCrewRatesByUserId(userId: number): Promise<CrewRates> {
        const crewRates = await this.api.request(
            { method: 'GET', url: `/crew-rates/${userId}` },
            CrewRatesSchema
        );
        return crewRates;
    }
} 